module.exports = __webpack_public_path__ + "expand_more-v1-a8805b8c.svg";